import React, { useState, useRef, useEffect } from 'react';
import { Droppable } from '@hello-pangea/dnd';
import Card from '../Card';
import PlusIcon from '../icons/PlusIcon';
import {
    CardList,
    AddCardButton,
    AddCardControls,
    AddCardInput,
    SaveCardButton
} from '../../styles/Column.styles';

const ColumnContent = ({
    column,
    cards,
    labels,
    onCardClick,
    areLabelsExpanded,
    onToggleLabels,
    projectMembers,
    onAddCard,
    limitColumnHeight,
    enableGithubLinks, // Add new prop
    projectId,         // New: Accept projectId
    allColumns,        // New: Accept allColumns
    columnOrder,       // New: Accept columnOrder
    projectLabels      // New: Accept projectLabels
}) => {
    const [isAddingCard, setIsAddingCard] = useState(false);
    const [newCardName, setNewCardName] = useState('');
    const addCardInputRef = useRef(null);

    useEffect(() => {
        if (isAddingCard && addCardInputRef.current) {
            addCardInputRef.current.focus();
        }
    }, [isAddingCard]);

    const handleSaveCard = () => {
        if (newCardName.trim() !== '') {
            onAddCard(column.id, newCardName.trim());
            setNewCardName('');
            setIsAddingCard(false);
        }
    };

    const handleCancelAddCard = () => {
        setNewCardName('');
        setIsAddingCard(false);
    };

    return (
        <>
            <Droppable droppableId={column.id} type="CARD">
                {(provided, snapshot) => (
                    <CardList
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                        isDraggingOver={snapshot.isDraggingOver}
                        limitColumnHeight={limitColumnHeight}
                    >
                        {Array.isArray(cards) && cards.map((card, index) => (
                            <Card
                                key={card.id}
                                card={card}
                                index={index}
                                onClick={() => onCardClick(card)}
                                labels={labels}
                                areLabelsExpanded={areLabelsExpanded}
                                onToggleLabels={onToggleLabels}
                                projectMembers={projectMembers}
                                enableGithubLinks={enableGithubLinks} // Pass down
                                projectId={projectId} // Pass down
                                columnId={column.id} // Pass down column.id as columnId
                                allColumns={allColumns} // Pass down
                                columnOrder={columnOrder} // Pass down
                                projectLabels={projectLabels} // Pass down projectLabels
                            />
                        ))}
                        {provided.placeholder}
                    </CardList>
                )}
            </Droppable>

            {isAddingCard ? (
                <AddCardControls>
                    <AddCardInput
                        ref={addCardInputRef}
                        type="text"
                        value={newCardName}
                        onChange={(e) => setNewCardName(e.target.value)}
                        onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                                handleSaveCard();
                            } else if (e.key === 'Escape') {
                                handleCancelAddCard();
                            }
                        }}
                        onBlur={handleCancelAddCard}
                        placeholder="Enter card name..."
                    />
                    <SaveCardButton onClick={handleSaveCard} aria-label="Save card">
                        <PlusIcon color="#bbb" width={16} height={16} />
                    </SaveCardButton>
                </AddCardControls>
            ) : (
                <AddCardButton
                    onClick={() => setIsAddingCard(true)}
                    title="Add a card"
                >
                    + Add another card
                </AddCardButton>
            )}
        </>
    );
};

export default ColumnContent;